<template>
  <div class="service-slider row">
    <div class="col-12 col-lg-10 col-xl-8 mx-auto">
      <carousel :items-to-show="this.display" :transition="400" :wrapAround="true" :autoplay="0">
        <slide v-for="(service, i) in services" :key="this.counter = i">
          <service-card 
            :service="service" 
            :button-text="text.services.buttonTitle" 
            :public-path="publicPath"
            @card-click="scroolTop"
          />
        </slide>
        <template #addons>
          <CarouselNavigation />
          <CarouselPagination />
        </template>
      </carousel>
    </div>
  </div>
</template>

<script>

import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination as CarouselPagination, Navigation as CarouselNavigation } from 'vue3-carousel';
import json from '../../text.json'
import ServiceCard from './serviceCard.vue'

export default {
  name: "service-slider",

  components: {
    Carousel,
    Slide,
    CarouselPagination,
    CarouselNavigation,
    ServiceCard
  },

  data() {
    return {
      text: json,
      display: 0,
      counter: 0,
      services: [],
      publicPath: '/'
    }
  },

  methods: {
    onResize() {
      if (window.innerWidth > 992) {
        this.$data.display = 3
        this.lineWidth = 70
      } else if (window.innerWidth > 575) {
        this.$data.display = 2
        this.lineWidth = 100
      } else if (window.innerWidth < 575) {
        this.$data.display = 1
        this.lineWidth = 100
      }
    },

    scroolTop() {
      window.scrollTo(0, 0)
    }
  },

  created() {   
    this.onResize();
    window.addEventListener('resize', this.onResize);
   
    for (let service of this.text.services.category[0].items) {
      this.services.push(service)
    }
    
    const zootherapy = {}
    zootherapy.title = this.text.services.category[1].name
    zootherapy.description = this.text.services.category[1].description
    zootherapy.imageCircular = this.text.services.category[1].items[0].image
    this.services.push(zootherapy)
  },
}
</script>

<style scoped>

</style>
